import React from 'react';
import './Button.css';

const Button = ({ callFunction, buttonName, enabled, callClick, size }) => {
  const isEnabled = (enable) => {
    let isInputEnabled;
    switch(enable){
      case true:
        isInputEnabled = '';
        break;
      case false:
        isInputEnabled = 'disabled';
        break;
      default:
        isInputEnabled = ''
    }
    return isInputEnabled;
  }

  return (
    <button
      name={buttonName}
      className={size ? `btn btn-secondary btn-continuar btn-${size}`:`btn btn-secondary btn-continuar`}
      type="submit"
      onSubmit={callFunction}
      onClick={callClick}
      disabled={isEnabled(enabled)}
    >
      {' '}
      {buttonName}
      {' '}
    </button>
  );
};

export default Button;
